import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import {
  Link,
  useI18next,
  useTranslation,
} from "@zestia/gatsby-plugin-react-i18next"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import findImage from "@/utils/find-image"

const RecommendedReading = ({ slug }) => {
  const { t } = useTranslation()
  const { language } = useI18next()

  const data = useStaticQuery(graphql`
    query {
      allMdx(
        sort: { frontmatter: { date: DESC } }
        filter: { frontmatter: { hidden: { ne: true } } }
      ) {
        edges {
          node {
            fields {
              lang
            }
            frontmatter {
              title
              slug
              preview_image {
                alt
                src {
                  childImageSharp {
                    gatsbyImageData(
                      formats: AUTO
                      width: 400
                      placeholder: BLURRED
                    )
                  }
                }
              }
            }
          }
        }
      }

      allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativePath: { eq: "blog/generic-image.png" }
        }
      ) {
        edges {
          node {
            childImageSharp {
              gatsbyImageData(width: 400, placeholder: BLURRED)
            }
          }
        }
      }
    }
  `)

  const { allFile, allMdx } = data

  const post = allMdx.edges.find(
    post =>
      post.node.frontmatter.slug === slug && post.node.fields.lang === language,
  )?.node

  if (!post) {
    throw new Error(`No post with the slug "${slug}" found`)
  }

  return (
    <Link className="recommended-reading" to={slug}>
      <div className="recommended-reading__image">
        <GatsbyImage
          image={
            getImage(post.frontmatter.preview_image?.src) ??
            getImage(findImage(allFile, "generic-image"))
          }
          alt={post.frontmatter.preview_image?.alt ?? post.frontmatter.title}
        />
      </div>

      <div className="recommended-reading__text">
        <p className="mb-0 p--sm recommended-reading__kicker">
          {t("blog.recommended-reading")}
        </p>

        <h2 className="h6 recommended-reading__title">
          {post.frontmatter.title}
        </h2>
      </div>
    </Link>
  )
}

export default RecommendedReading
